import { PROXIMA_NOVA_FONT_FAMILY, PROXIMA_NOVA_T_FONT_FAMILY } from './global/styles';
import overrides from '../src/theme-config/overrides';

const getDefaultTheme = (paletteType) => ({
  palette: {
    common: {
      black: '#000',
      white: '#fff',
      gray: 'rgba(0, 0, 0, 0.6)',
    },
    surface: {
      light: {
        breadcrumb: {
          color: '#001eff',
          disabledColor: 'rgba(0, 0, 0, 0.87)',
        },
        level0: {
          bgColor: '#f5f5f5',
          color: '#000',
          drawerLeftBgColor: '#001eff',
          toolTipBgColor: '#f5f5f5',
        },
        level1: {
          bgColor: '#fff',
        },
        level2: {
          bgColor: '#fff',
        },
        level3: {
          bgColor: '#fff',
          hoverColor: 'rgba(0, 0, 0, 0.05)',
          color: '#000',
        },
        level4: {
          bgColor: '#fff',
        },
        menuIcon: {
          color: '#000',
          selectedColor: '#001eff',
        },
        smallCard: {
          bgColor: '#fff',
          labelColor: 'rgba(0, 0, 0, 0.6)',
          textColor: 'rgba(0, 0, 0, 0.87)',
          linkColor: '#001eff',
          optionBgColor: '#fff',
          optionColor: 'rgba(0, 0, 0, 0.38)',
          optionBorder: 'solid 1px rgba(0, 0, 0, 0.38)',
          iconColor: 'rgba(0, 0, 0, 0.6)',
        },
        button: {
          contained: {
            bgColor: '#001eff',
            hoveredBgColor: '#000f7f',
            border: 'solid 1px',
            disabled: {
              color: ' rgba(0, 0, 0, 0.38)',
              backgroundColor: 'rgba(0, 0, 0, 0.05)',
            },
          },
          outlined: {
            color: '#001eff',
            bgColor: '#fff',
            border: 'solid 1px #001eff',
            hoveredBorder: 'solid 1px #001eff',
            hoveredBgColor: 'rgba(0, 30, 255, 0.04)',
            selectedBorder: 'solid 1px #001eff',
            selectedBgColor: 'rgba(0, 30, 255, 0.12)',
            disabled: {
              color: 'rgba(0, 0, 0, 0.38)',
              backgroundColor: 'rgba(255, 255, 255, 0.12)',
              border: 'solid 1px rgba(0, 0, 0, 0.38)',
            },
          },
          text: {
            color: '#001eff',
            borderBottom: 'solid 1px  #001eff',
            disabled: {
              color: 'rgba(0, 0, 0, 0.38)',
            },
          },
        },
        table: {
          main: {
            backgroundColor: '#fff',
            color: '#000000',
          },
          icon: {
            color: 'rgba(0,0,0,0.6)',
            disabled: {
              color: 'rgba(0, 0, 0, 0.26)',
            },
          },
          head: {
            backgroundColor: '#f2f2f2',
            color: '#141823',
            hoverColor: '#aaa',
          },
          stickyHead: {
            backgroundColor: '#fff',
            color: '#141823',
            hoverColor: '#aaa',
          },
          cell: {
            color: '#000000',
            borderBottom: '1px solid rgb(244, 244, 244)',
          },
          footer: {
            backgroundColor: '#ffffff',
            color: '#141823',
            icon: {
              color: 'rgba(0, 0, 0, 0.54)',
              disabled: {
                color: 'rgba(0, 0, 0, 0.26)',
              },
            },
            download: {
              color: '#001eff',
            },
          },
        },
        dialog: {
          barColor: '#001eff',
          color: '#000',
          bgColor: '#fff',
          subTitle: 'rgba(0, 0, 0, 0.87)',
        },
        textField: {
          labelColor: 'rgba(0, 0, 0, 0.87)',
          helpTextColor: 'rgba(0, 0, 0, 0.6)',
          defaultBorderColor: 'rgba(0, 0, 0, 0.38)',
          hoveredBorderColor: '#000000',
          activedBorderColor: '#001eff',
          disabledBorderColor: 'rgba(0, 0, 0, 0.2)',
          readonlyBorderColor: 'rgba(0,0,0,0.38)',
          defaultColor: 'rgba(0, 0, 0, 0.38)',
          hoveredColor: 'rgba(0, 0, 0, 0.38)',
          activedColor: 'rgba(0, 0, 0, 0.87)',
          disabledColor: 'rgba(0, 0, 0, 0.2)',
          readonlyColor: '#000',
          asteriskColor: '#e02020',
        },
        tableStyle: {
          head: {
            background: '#eee',
            color: 'rgba(0, 0, 0, 0.87)',
            hovered: {
              bgColor: 'rgba(0, 0, 0, 0.05)',
              color: 'rgba(0, 0, 0, 0.87)',
              svgColor: 'rgba(0, 0, 0, 0.6)',
            },
            selected: {
              bgColor: 'rgba(0, 30, 255, 0.12)',
              color: '#ccc',
            },
          },
          row: {
            zebraConfig: {
              even: '#f2f2f2',
              odd: '#ffffff',
            },
            hovered: {
              bgColor: 'rgba(0, 30, 255, 0.12)',
            },
            selected: {
              bgColor: 'rgba(0, 30, 255, 0.12)',
            },
            disabled: {
              bgColor: 'rgba(0, 0, 0, 0.05)',
            },
            linkColor: {
              color: '#001eff',
            },
          },
          pagination: {
            color: '#000',
            disabledColor: 'rgba(0,0,0,0.2)',
            selectedColor: 'rgba(102, 120, 255, 0.3)',
          },
          stickyHeader: {
            bgColor: '#eee',
            hoverBgColor: 'rgba(0, 0, 0, 0.05)',
          },
          selectWidget: {
            color: '#000',
          },
        },
        errorToolTip: {
          color: '#B20015',
          bgColor: '#FFC8CE',
          hint: {
            color: 'rgba(0, 0, 0, 0.6)',
          },
        },
        page: {
          background: '#fff',
          titleColor: 'rgba(0, 0, 0, 0.87)',
          textColor: 'rgba(0, 0, 0, 0.6)',
        },
      },
      dark: {
        breadcrumb: {
          color: '#ccd2ff',
          disabledColor: '#ccc',
        },
        level0: {
          bgColor: '#0D0D0D',
          color: '#fff',
          drawerLeftBgColor: '#324aff',
          toolTipBgColor: '#222',
        },
        level1: {
          bgColor: '#404040',
        },
        level2: {
          bgColor: '#333333',
        },
        level3: {
          bgColor: '#262626',
          hoverColor: '#333333',
          color: '#fff',
        },
        level4: {
          bgColor: '#1A1A1A',
        },
        menuIcon: {
          color: '#ccc',
          selectedColor: '#6678ef',
        },
        smallCard: {
          bgColor: '#333',
          labelColor: 'rgba(255, 255, 255, 0.7)',
          textColor: '#fff',
          linkColor: '#ccd2ff',
          optionBgColor: '#333',
          optionColor: 'rgba(255, 255, 255, 0.7)',
          optionBorder: 'solid 1px #cccccc',
          iconColor: '#cccccc',
        },
        button: {
          contained: {
            bgColor: '#334bff',
            hoveredBgColor: '#rgba(0, 0, 0, 0.04)',
            border: 'solid 1px #fff',
            disabled: {
              color: ' rgba(204, 204, 204, 0.5)',
              backgroundColor: '#333333',
            },
          },
          outlined: {
            color: '#ccd2ff',
            bgColor: '#0d0d0d',
            border: 'solid 1px #808080',
            hoveredBorder: 'solid 1px #808080',
            hoveredBgColor: 'rgba(102, 120, 255, 0.1)',
            selectedBorder: 'solid 1px #808080',
            selectedBgColor: 'rgba(102, 120, 255, 0.3)',
            disabled: {
              color: '#808080',
              backgroundColor: '#0d0d0d',
              border: 'solid 1px #808080',
            },
          },
          text: {
            color: '#ccd2ff',
            borderBottom: 'solid 1px  #334bff',
            disabled: {
              color: 'rgba(255, 255, 255, 0.5)',
            },
          },
        },
        table: {
          main: {
            backgroundColor: '#1a1a1a',
            color: '#cccccc',
          },
          icon: {
            color: '#cccccc',
            disabled: {
              color: '#404040',
            },
          },
          head: {
            backgroundColor: '#262626',
            color: '#cccccc',
            hoverColor: '#fff',
          },
          stickyHead: {
            backgroundColor: '#262626',
            color: '#cccccc',
            hoverColor: '#fff',
          },
          cell: {
            color: '#cccccc',
            borderBottom: '1px solid rgba(255, 255, 255, 0.12)',
          },
          footer: {
            backgroundColor: '#262626',
            color: '#cccccc',
            icon: {
              color: '#cccccc',
              disabled: {
                color: '#404040',
              },
            },
            download: {
              color: '#334bff',
            },
          },
        },
        dialog: {
          barColor: '#334bff',
          color: '#fff',
          bgColor: '#121212',
          subTitle: '#ccc',
        },
        textField: {
          labelColor: 'rgba(255, 255, 255, 0.7)',
          helpTextColor: 'rgba(255, 255, 255, 0.7)',
          defaultBorderColor: '#cccccc',
          hoveredBorderColor: '#f8f8f8',
          activedBorderColor: '#6678ff',
          disabledBorderColor: '#404040',
          readonlyBorderColor: '#cccccc',
          defaultColor: 'rgba(255, 255, 255, 0.7)',
          hoveredColor: '#fff',
          activedColor: '#fff',
          disabledColor: 'rgba(255, 255, 255, 0.5)',
          readonlyColor: '#fff',
          asteriskColor: '#f5475b',
        },
        tableStyle: {
          head: {
            background: '#0d0d0d',
            color: '#ccc',
            hovered: {
              background: '#333',
              color: '#ccc',
              svgColor: '#ccc',
            },
            selected: {
              background: 'rgba(102, 120, 255, 0.1)',
              color: '#ccc',
            },
          },
          row: {
            zebraConfig: {
              even: '#0d0d0d',
              odd: '#0d0d0d',
            },
            hovered: {
              bgColor: '#262626',
            },
            selected: {
              bgColor: 'rgba(102, 120, 255, 0.1)',
            },
            disabled: {
              bgColor: '#1a1a1a',
            },
            linkColor: {
              color: '#ccd2ff',
            },
          },
          pagination: {
            color: '#ccc',
            disabledColor: '#404040',
            selectedColor: 'rgba(102, 120, 255, 0.3)',
          },
          stickyHeader: {
            bgColor: '#0d0d0d',
            hoverBgColor: '#0d0d0d',
          },
          selectWidget: {
            color: '#ccc',
          },
        },
        errorToolTip: {
          color: '#b20015',
          bgColor: '#ffc8ce',
          hint: {
            color: 'rgba(255, 255, 255, 0.7)',
          },
        },
        page: {
          background: '#0d0d0d',
          titleColor: '#fff',
          textColor: '#ccc',
        },
      },
    },
    type: 'light',
    primary: {
      light: '#6678ef', // #6678FF
      main: '#001eff', // #334BFF
      dark: '#0f1e8A', // #0F1E8A
      contrastText: '#fff',
    },
    secondary: {
      light: '#ffde66', // theme: dark #ffde66
      main: '#ffc800', // theme:dark #ffd333
      dark: '#997800', // theme:dark #806400
      contrastText: '#fff',
    },
    error: {
      light: '#ff334b', // theme:dark #f76b7b
      main: '#ff001e', // theme:dark #f5475b
      dark: '#b30021', // theme:dark #a01c2b
      contrastText: '#fff',
    },
    warning: {
      light: '#ff5100', // theme:dark #ff9666
      main: '#ff5100', // theme:dark #FF7333
      dark: '#ff9300', // theme:dark #993000
      contrastText: '#fff',
    },
    info: {
      light: '#60cf8b', // theme:dark 59dfe1
      main: '#00c389', // theme:dark 2dd6da
      dark: '#227542', // theme:dark 007678
      contrastText: '#fff',
    },
    success: {
      light: '#33cfa0', // theme:dark #60cf8b
      main: '#00C389', // theme:dark #39c46e
      dark: '#00885f', // theme:dark #227542
      contrastText: '#fff',
    },
    contrastThreshold: 3,
    tonalOffset: 0.2,
    text: {
      primary: 'rgba(0, 0, 0, 0.87)',
      secondary: 'rgba(0, 0, 0, 0.6)',
      disabled: 'rgba(0, 0, 0, 0.38)',
      hint: 'rgba(0, 0, 0, 0.38)',
    },
    divider: 'rgba(0, 0, 0, 0.12)',
    background: {
      paper: '#fff',
      default: '#fafafa',
    },
    action: {
      hover: 'rgba(0, 0, 0, 0.04)',
      disabledBackground: '#ccd2ff',
      hoverOpacity: 0.08,
      // selected: 'rgba(0, 30, 255, 0.08)',
      disabled: 'rgba(0, 0, 0, 0.26)',
      hoveredBackground: '#000f7f',
    },
    icon: {
      disabled: 'rgba(0, 0, 0, 0.2)',
    },
  },
  typography: {
    htmlFontSize: 16,
    fontFamily: PROXIMA_NOVA_FONT_FAMILY,
    fontSize: 14,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 700,
    h1: {
      fontFamily: PROXIMA_NOVA_T_FONT_FAMILY,
      fontSize: '96px',
      fontWeight: 100,
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: 1.17,
      letterSpacing: '-1.5px',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    h2: {
      fontFamily: PROXIMA_NOVA_T_FONT_FAMILY,
      fontSize: '60px',
      fontWeight: 100,
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: 1.2,
      letterSpacing: '-0.5px',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    h3: {
      fontFamily: PROXIMA_NOVA_FONT_FAMILY,
      fontSize: '48px',
      fontWeight: 'normal',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: 1.17,
      letterSpacing: 'normal',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    h4: {
      fontFamily: PROXIMA_NOVA_FONT_FAMILY,
      fontSize: '34px',
      fontWeight: 'normal',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: 1.06,
      letterSpacing: 'normal',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    h5: {
      fontFamily: PROXIMA_NOVA_FONT_FAMILY,
      fontSize: '24px',
      fontWeight: 'bold',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: 1.5,
      letterSpacing: '0.18px',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    h6: {
      fontFamily: PROXIMA_NOVA_FONT_FAMILY,
      fontSize: '20px',
      fontWeight: 'bold',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: 1.2,
      letterSpacing: '0.15px',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    subtitle1: {
      fontFamily: PROXIMA_NOVA_FONT_FAMILY,
      fontSize: '16px',
      fontWeight: 'normal',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: 1.5,
      letterSpacing: '0.15px',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    subtitle2: {
      fontFamily: PROXIMA_NOVA_FONT_FAMILY,
      fontSize: '14px',
      fontWeight: 'normal',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: 1.71,
      letterSpacing: '0.1px',
      color: '#000',
    },
    body1: {
      fontFamily: PROXIMA_NOVA_FONT_FAMILY,
      fontSize: '16px',
      fontWeight: 'normal',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: 1.5,
      letterSpacing: '0.5px',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    body2: {
      fontFamily: PROXIMA_NOVA_FONT_FAMILY,
      fontSize: '14px',
      fontWeight: 'normal',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: 1.43,
      letterSpacing: '0.25px',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    withIconButton: {
      paddingLeft: 12,
    },
    button: {
      fontFamily: PROXIMA_NOVA_FONT_FAMILY,
      fontSize: '14px',
      fontWeight: 'normal',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: 'normal',
      letterSpacing: '1.25px',
      textAlign: 'center',
      height: 36,
    },
    buttonOutlined: {
      borderWidth: '1px',
      borderStyle: 'solid',
      hoveredBackground: 'rgba(0, 30, 255, 0.04)',
    },
    buttonText: {
      paddingRight: 3,
    },
    caption: {
      fontFamily: PROXIMA_NOVA_FONT_FAMILY,
      fontSize: '12px',
      fontWeight: 'normal',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: 1.33,
      letterSpacing: '0.4px',
    },
    overline: {
      fontFamily: PROXIMA_NOVA_FONT_FAMILY,
      fontSize: '10px',
      fontWeight: 'normal',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: 1.6,
      letterSpacing: '1.5px',
      color: 'rgba(0, 0, 0, 0.87)',
    },
  },
  overrides: overrides[paletteType],
});

export default getDefaultTheme;
